/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S6_Label_KepInputs */

const tr_iletisim_s6_label_kep = /** @type {(inputs: Iletisim_S6_Label_KepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KEP Adresi`)
};

const en_iletisim_s6_label_kep = /** @type {(inputs: Iletisim_S6_Label_KepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KEP address`)
};

const de_iletisim_s6_label_kep = /** @type {(inputs: Iletisim_S6_Label_KepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KEP-Adresse`)
};

const ru_iletisim_s6_label_kep = /** @type {(inputs: Iletisim_S6_Label_KepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес KEP`)
};

/**
* | output |
* | --- |
* | "KEP address" |
*
* @param {Iletisim_S6_Label_KepInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s6_label_kep = /** @type {((inputs?: Iletisim_S6_Label_KepInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S6_Label_KepInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s6_label_kep(inputs)
	if (locale === "de") return de_iletisim_s6_label_kep(inputs)
	if (locale === "ru") return ru_iletisim_s6_label_kep(inputs)
	return tr_iletisim_s6_label_kep(inputs)
});